<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation :tenant="tenant_id"></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-rights ui-mt-15 pull-right">
                            <div class="dropdown">
                                <button type="button" 
                                    class="btn btn-dark btn-sm dropdown-toggle" 
                                    data-toggle="dropdown"
                                    aria-haspopup="true" 
                                    aria-expanded="false" 
                                    :disabled="tenantLoading">
                                    <span class="btn-icon ti-home mr-2"></span>
                                    <span v-if="!tenantLoading" class="ui-mr5"> {{ tenant_name }}</span>
                                    <span v-if="tenantLoading">
                                        <span class="spinner-grow spinner-grow-sm mr-1" 
                                            role="status" 
                                            aria-hidden="true">
                                        </span>Loading...
                                    </span>
                                </button>
                                <div class="dropdown-menu">
                                    <a v-if="auth.role == 'root'"
                                        class="dropdown-item dropdown-pad" 
                                        href="javascript:;"
                                        @click="changeTenant(0, 'All Tenants')"> All Tenants
                                    </a>
                                    <a class="dropdown-pad dropdown-item" 
                                        href="javascript:;"
                                        v-for="(tenant, index) in tenants"
                                        :key="index"
                                        :class="(tenant.authority) ? '' : 'hidden'"
                                        @click="changeTenant(tenant.id, tenant.name)"> 
                                           &nbsp; {{ tenant.name }} &nbsp;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Tenants -->
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize active" aria-current="page">
                                {{ refs }}
                            </li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->
                
                

            <!-- Content  -->
            <div class="row">
                <!-- <div class="col-md-12">
                    <div class="pull-rights ui-mt-50 pull-right ">
                        <div class="dropdown ui-mr5">
                            <span class="badge badge-md badge-pill badge-danger-soft">
                                File Size 
                                <span v-if="dataLoading">
                                    <div class="spinner-grow spinner-grow-sm mr-1" role="status">
                                          <span class="sr-only">Loading...</span>
                                    </div>
                                </span>
                                <span v-if="!dataLoading">{{fileSize}}</span>
                            </span>
                        </div>
                    </div>
                </div> -->

                <div class="col-md-8 mb-5">
                    <div class="card">

                    <div class="card-body">
                        <div class="table-responsive">
                            <table id="printMe" class="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Title</th>
                                        <th>File</th>
                                        <th class="text-center">Path</th>
                                        <!-- <th class="text-center">mimeType</th>
                                        <th class="text-center">Size</th> -->
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                
                                <tbody v-if="dataLoading">
                                    <tr>
                                        <td colspan="5" class="text-center">
                                            <div class="spinner-grow" role="status">
                                              <span class="sr-only">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody v-if="!dataLoading && !rows.length">
                                    <tr>
                                        <td colspan="5" class="text-center">
                                            <span>No data found</span>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody v-if="!dataLoading && rows.length">
                                    <tr v-for="(row, index) in rows" 
                                        :key="index" 
                                        class="f14">

                                    <td class="font-weight-semi-bold">{{index+1}}</td>
                                    <td class="font-weight-semi-bold text-center">{{ row.title }}</td>

                                    <td class="font-weight-semi-bold">
                                        <a :href="row.image" target="_blank">
                                            <img :src="row.image.image_url" 
                                                style="width:92px">
                                        </a>
                                    </td>

                                    <td class="font-weight-semi-bold text-center">
                                        <a href="javascript:;" 
                                            title="Copy to clipboard"
                                            v-clipboard:copy="row.image.image_url"
                                            v-clipboard:success="onCopy"
                                            v-clipboard:error="onError">
                                            Copy to clipboard
                                        </a>
                                    </td>

                                    <!-- <td class="font-weight-semi-bold text-center">
                                        <span class="badge badge-md badge-pill badge-danger-soft">
                                            {{ row.mime_type }}
                                        </span>
                                    </td>
                                    <td class="font-weight-semi-bold text-center">{{ row.size }}</td> -->
                                    <td class="text-center">
                                        <div class="dropdown">
                                            <a id="tableWithImage1MenuInvoker" class="u-icon-sm link-muted" 
                                                href="javascript:;" role="button" aria-haspopup="true" aria-expanded="false"
                                                data-toggle="dropdown"
                                                data-offset="8">
                                                <span v-if="!row.loading" class="ti-more"></span>
                                                <span v-if="row.loading" class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" aria-hidden="true">
                                                </span>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right" 
                                                style="width: 150px">
                                                <div class="card border-0 p-3">
                                                    <ul class="list-unstyled mb-0">
                                                        <li v-if="permissions.edit && !row.trash">
                                                            <a href="javascript:;"
                                                                @click="editRow(row)" 
                                                                class="d-block link-dark">
                                                                Edit
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a v-if="permissions.delete" 
                                                                @click="row.loading = true; 
                                                                deletePermanently(row.id)"
                                                                class="d-block link-dark" 
                                                                href="javascript:;">Delete Permanently
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>#</th>
                                        <th>Title</th>
                                        <th>File</th>
                                        <th class="text-center">Path</th>
                                        <!-- <th class="text-center">mimeType</th>
                                        <th class="text-center">Size</th> -->
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </tfoot>

                            </table>
                        </div>
                        <nav  v-if="rows.length !== 0" aria-label="Page navigation example ui-mt20" 
                            style="margin-top: 20px">
                            <ul class="pagination">
                                <li v-bind:class="[{disabled: !pagination.prev_page_url}]" class="page-item">
                                    <a class="page-link" href="javascript:" 
                                        @click="fetchData(pagination.prev_page_url)">Previous</a>
                                </li>
                                <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item">
                                    <a class="page-link" href="javascript:" 
                                        @click="fetchData(pagination.next_page_url)">Next</a>
                                </li>
                            </ul>
                            <p class="pull-right ui-mt-50 f13">
                                <i>Page {{ pagination.current_page }} or {{ pagination.last_page }}</i>
                            </p>
                        </nav>

                    </div>
                </div>
            </div>



            <div class="col-md-4 mb-5">
                <div class="card">
                    <header class="card-header">
                        <h2 class="h4 card-header-title" 
                                v-html="(btn_status == 'Update') ? 'Edit Row' : 'Add New'"></h2>
                    </header>

                <form @submit.prevent="createOrUpdate" enctype="multipart/form-data">
                    <div class="card-body pt-0">

                        <!-- Title -->
                        <div class="form-group">
                            <label for="inputText1">Title</label>
                            <input class="form-control" 
                                    id="inputText1" 
                                    type="text" 
                                    v-model="row.title">
                        </div>
                        <!-- End Title -->
                        
                        <div class="form-group">
                            <img v-if="row.preview" 
                                :src="row.preview" 
                                style="width: 100%;max-height: 300px;padding:10px">
                            <input class="form-control" 
                                    type="file"
                                    ref="myDropify"
                                    v-on:change="onImageChange"
                                    accept="image/*,video/*"
                                    :required="!row.encrypt_id">
                        </div>
                        
                        <!-- View in gallery -->
                        <div class="form-group">
                            <div class="custom-control custom-switch mb-2">
                                <input type="checkbox" 
                                    class="custom-control-input" 
                                    id="customSwitch22" 
                                    :checked="row.view_in_gallery"
                                    @click="onGallery">
                                <label class="custom-control-label" 
                                    for="customSwitch22"
                                    v-html="(row.view_in_gallery) 
                                        ? 'Show In Gallery' : 'Hide In Gallery'">
                                </label>
                            </div>
                        </div>
                        <!-- End View in gallery -->
                        
                        <div class="form-group">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Uploading... {{ uploadProgress }}%
                                </span>
                                <span v-if="!btnLoading" class="ti-upload"></span>
                                <span v-if="!btnLoading"> Upload to AWS</span>
                            </button>
                        </div>

                    </div>
                </form>

                </div>
            </div>

            </div>
        </div>
        <!-- End Content Body -->

            <Footer></Footer>
        </div>

        </main>
        <!-- End Main -->
        
    </div>
</template>

<script src="vue.min.js"></script>
<script src="dist/vue-clipboard.min.js"></script>
<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import iziToast from 'izitoast';

    export default {
        name: 'Media',
        components: {
            Header,
            Navigation,
            Footer,
        },
        data(){
            return {
                exp: {
                   json_fields: {
                        'id': 'id',
                        'timestamp': 'timestamp',
                    }, 
                    json_data: [],
                    json_meta: [
                        [{
                            'key': 'charset',
                            'value': 'utf-8'
                        }]
                    ],
                },
                auth: { 
                    role: '',
                    access_token: '',
                },
                row: {
                    encrypt_id: '',
                    preview: '',
                    base64Image: '',
                    file: '',
                    view_in_gallery: 0,
                    title: '',
                },
                permissions: {
                    add: false,
                    edit: false,
                    delete: false
                },
                status: '',

                //
                fileSize: '',
                dataLoading: true,
                btnLoading: false,
                something_went_wrong: false,
                rows: [],
                pagination: {},
                edit: false,
                btn_status: 'Create',
                chunkSize: 30 * 1024 * 1024, // 5MB chunks
                currentChunk: 0,
                totalChunks: 0,
                uniqueIdentifier: '',
                uploadProgress: 0,
                cancelToken: null,

                // Tenants
                tenant_id: 0,
                tenant_name: 'All Tenants',
                tenantLoading: true,
                tenants: [],

                refs: 'media'
            }
        },
        mounted() {},
        watch: {
          $route() {
            // Status By
            if(this.$route.params.status) {
                this.status = this.$route.params.status;
            } else {
                this.status = '';
            }

            this.fetchData('', true);
          }
        },
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchTenants();
        },
        methods: {

            changeTenant(id, name) {
                this.tenantLoading = true;
                this.tenant_id = id;
                this.tenant_name = name;
                localStorage.setItem('tenant_id', id);
                localStorage.setItem('tenant_name', name);
                this.fetchData('', true);
            },

            fetchTenants(){
                this.tenantLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tenants',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        paginate: 100
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.tenantLoading = false;
                        this.tenants = res.data.rows;

                        if(this.auth.role != 'root') {
                            if(!localStorage.getItem('tenant_id')) {
                                this.tenant_id = res.data.rows[0].id;
                                this.tenant_name = res.data.rows[0].name;
                            }
                        }
                        this.fetchData('', true); // fetch data
                    })
                    .catch(err => {
                        // 403 Forbidden
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else {
                            this.btnLoading = false;
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {})
            },

            // Fetch Data
            fetchData(page_url, loading=false) {
                if(loading) { this.dataLoading = true; }
                this.something_went_wrong = false;
                
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                let vm = this;
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/'+this.refs,
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                    },
                }
                this.axios(options, config)
                    .then(res => {
                        this.dataLoading = false;
                        this.tenantLoading = false;
                        this.edit = false;
                        this.btn_status = 'Create';

                        this.permissions.add = res.data.permissions.add;
                        this.permissions.edit = res.data.permissions.edit;
                        this.permissions.delete = res.data.permissions.delete;

                        this.rows = res.data.rows;
                        // this.fileSize = res.data.fileSize;
                        // console.log(this.fileSize);
                        if(res.data.paginate.total) {
                            vm.makePagination(res.data.paginate)
                        }

                        // Exception for 403
                        if(!res.data.permissions.view) {
                            this.$router.push({ name: 'forbidden' });
                        }
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },

            // Pagination
            makePagination(meta) {
                let pagination = {
                    current_page: meta.current_page,
                    last_page: meta.last_page,
                    next_page_url: meta.next_page_url,
                    prev_page_url: meta.prev_page_url
                }
                this.pagination = pagination;
            },

            // Upload Featured image
            onImageChange(e){
                // const file = e.target.files[0];
                // this.row.preview = URL.createObjectURL(file);
                // this.createBase64Image(file);
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.row.file = file;
            },

            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.base64Image = e.target.result;
                };
            },

            async uploadChunk(file, chunkNumber) {
                const start = (chunkNumber - 1) * this.chunkSize;
                const end = Math.min(start + this.chunkSize, file.size);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append('file', chunk);  // Don't include filename here
                formData.append('chunkNumber', chunkNumber);
                formData.append('totalChunks', this.totalChunks);
                formData.append('originalName', file.name);
                formData.append('uniqueIdentifier', this.uniqueIdentifier);

                // for (const pair of formData.entries()) {
                //     console.log(pair[0], pair[1]);
                // }

                const instance = this.axios.create({
                    baseURL: window.baseURL,
                    headers: {
                    'Authorization': `Bearer ${this.auth.access_token}`,
                    'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                return instance.post('/upload-chunk', formData);
            },

            async combineChunks() {
                const instance = this.axios.create({
                    baseURL: window.baseURL,
                    headers: {
                    'Authorization': `Bearer ${this.auth.access_token}`,
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                return instance.post('/combine-chunks', {
                    totalChunks: this.totalChunks,
                    originalName: this.row.file.name,
                    uniqueIdentifier: this.uniqueIdentifier,
                    folder: 'media'
                });
                // return this.axios.post(window.baseURL + '/combine-chunks', {
                //     totalChunks: this.totalChunks,
                //     originalName: this.row.file.name,
                //     uniqueIdentifier: this.uniqueIdentifier,
                //     folder: 'media' // Match your backend folder
                // }, {
                //     headers: {
                //     'Authorization': `Bearer ${this.auth.access_token}`,
                //     'Content-Type': 'application/json'
                //     }
                // });
            },

            async saveMedia(fileUrl) {
                return this.axios.post(window.baseURL + '/media', {
                    tenant_id: this.tenant_id,
                    file: fileUrl,
                    view_in_gallery: this.row.view_in_gallery,
                    title: this.row.title,
                }, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ${this.auth.access_token}`
                    }
                });
            },

            resetForm() {
                this.row.preview = '';
                this.row.file = null;
                this.row.title = '';
                this.row.view_in_gallery = 0;
                this.$refs.myDropify.value = '';
                this.uploadProgress = 0;
                this.fetchData();
            },


            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // Edit
            editRow(row) {
                this.edit = true;
                this.btn_status = 'Update';
                // this.row.id = row.id;

                this.row.encrypt_id = row.encrypt_id;
                this.row.view_in_gallery = row.view_in_gallery;
                this.row.title = row.title;
                this.row.preview = row.image.image_url;
                this.row.base64Image = row.base64Image;

                // tenant
                this.tenant_id = row.tenant_id;
                this.tenant_name = row.tenant_name;
            },

            // createOrUpdate
            // createOrUpdate() {

            //     if(this.tenant_id == 0) {
                    
            //         iziToast.warning({
            //             icon: 'ti-alert',
            //             title: 'Wow-man,',
            //             message: 'No tenany selected.'
            //         });

            //     } else {

            //         if(this.row.view_in_gallery == false) {
            //             this.row.view_in_gallery = 0;
            //         } else {
            //             this.row.view_in_gallery = 1;
            //         }

            //         this.btnLoading = true;
            //         this.axios.defaults.headers.common = {
            //             'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            //             'Authorization': `Bearer ` + this.auth.access_token,
            //         };
            //         let type = 'POST';
            //         let path = this.refs;
            //         let msg  = 'Added';
            //         if(this.edit) {
            //             type = 'PUT';
            //             path = this.refs+'/'+this.row.encrypt_id;
            //             msg  = 'Updated';
            //         }
            //         const options = {
            //             url: window.baseURL+'/'+path,
            //             method: type,
            //             data: {
            //                 tenant_id: this.tenant_id,
            //                 file: this.row.base64Image,
            //                 view_in_gallery: this.row.view_in_gallery,
            //             }
            //         }
            //         this.axios(options)
            //         .then(() => {
            //             this.btnLoading = false;
            //             this.fetchData();

            //             // Clear rows
            //             this.row.encrypt_id = '';
            //             this.btnLoading = false;
            //             this.row.preview = '';
            //             this.row.base64Image = '';
            //             this.row.view_in_gallery = '',
            //             this.$refs.myDropify.value = '';

            //             iziToast.success({
            //                 icon: 'ti-check',
            //                 title: 'Great job,',
            //                 message: 'Item '+msg+' Successfully',
            //             });
            //         })
            //         .catch(err => {
            //             // 403 Forbidden
            //             if(err.response && err.response.status == 401) {
            //                 this.removeLocalStorage();
            //                 this.$router.push({ name: 'login' });
            //             } else if(err.response && err.response.status == 403) {
            //                 this.$router.push({ name: 'forbidden' });
            //             } else {
            //                 this.btnLoading = false;
            //                 iziToast.warning({
            //                     icon: 'ti-alert',
            //                     title: 'Wow-man,',
            //                     message: (err.response) ? err.response.data.message : ''+err
            //                 });
            //             }
            //         })
            //         .finally(() => {});
            //     }
            // },
            async createOrUpdate() {
                if (this.tenant_id === 0) {
                    return iziToast.warning({
                    icon: 'ti-alert',
                    title: 'Oops!',
                    message: 'No tenant selected.'
                    });
                }

                this.btnLoading = true;

                // 2) UPDATE‐ONLY PATH (no new file chosen, but editing an existing record)
                if (this.row.encrypt_id && !this.row.file) {
                    try {
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Authorization': `Bearer ${this.auth.access_token}`
                    };
                    await this.axios({
                        url: `${window.baseURL}/${this.refs}/${this.row.encrypt_id}`,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            title: this.row.title,
                            view_in_gallery: this.row.view_in_gallery ? 1 : 0
                        }
                    });
                    iziToast.success({
                        icon: 'ti-check',
                        title: 'Updated!',
                        message: 'Metadata updated successfully.'
                    });
                    this.resetForm();
                    } catch (err) {
                    iziToast.error({
                        icon: 'ti-na',
                        title: 'Update Failed',
                        message: err.response?.data?.message || err.message
                    });
                    } finally {
                        this.btnLoading = false;
                    }
                    return; 
                }

                // 3) UPLOAD PATH (create new, or editing + new file)
                try {
                    const file = this.row.file;
                    const fileSize = file.size;
                    this.totalChunks = Math.ceil(fileSize / this.chunkSize);
                    this.uniqueIdentifier = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${file.name.replace(/\.[^/.]+$/, "")}`;
                    
                    // Upload chunks sequentially
                    for (let chunkNumber = 1; chunkNumber <= this.totalChunks; chunkNumber++) {
                    await this.uploadChunk(file, chunkNumber);
                    this.uploadProgress = Math.round((chunkNumber / this.totalChunks) * 100);
                    }
                    
                    // Combine chunks
                    const response = await this.combineChunks();

                    // finally send record create/update
                    await this.saveMedia(response.data.file_url, {
                        tenant_id: this.tenant_id,
                        title: this.row.title,
                        view_in_gallery: this.row.view_in_gallery ? 1 : 0,
                        encrypt_id: this.row.encrypt_id
                    });

                    iziToast.success({
                        icon: 'ti-check',
                        title: 'Success!',
                        message: 'File and data uploaded successfully.'
                    });
                    this.resetForm();

                } catch (error) {
                    iziToast.error({
                    icon: 'ti-na',
                    title: 'Upload Failed',
                    message: error.response?.data?.message || error.message
                    });
                } finally {
                    this.btnLoading = false;
                }
            },

            onGallery(){
                if(this.row.view_in_gallery)
                    this.row.view_in_gallery = 0;
                else
                    this.row.view_in_gallery = 1;
            },

            // Delete Permanently
            deletePermanently(id) {
                if(confirm('Are You Sure?')) {
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer `+this.auth.access_token,
                    };
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+id,
                        method: 'DELETE',
                        data: {},
                    }
                  this.axios(options)
                    .then(() => {
                      this.fetchData(); 
                      iziToast.success({
                          icon: 'ti-check',
                          title: 'Great job,',
                          message: 'Item Deleted Permanently Successfully',
                      });
                        
                    })
                    .catch(() => {
                        this.fetchData(); 
                        iziToast.error({
                            icon: 'ti-na',
                            title: 'Wow-wow,',
                            message: 'Something went wrong',
                        });
                    })
                    .finally(() => {});
                } else { 
                    // In case Cancel Alert
                    this.fetchData(); 
                }
            },

            // Copy to Clipboard
            onCopy: function (e) {
                iziToast.success({
                    icon: 'ti-check',
                    title: 'Great job,',
                    message: 'Copy to Clipboard Successfully',
                });
            },
            onError: function (e) {
                iziToast.error({
                    icon: 'ti-na',
                    title: 'Wow-wow,',
                    message: 'Something went wrong, try again',
                });
            },
    
        },
    }
</script>

